import axiosInstance from "./axiosConfig";
import ApiConfig from "./config";

export const getDashboard = async (payload) => {
  const response = await axiosInstance.put(
    ApiConfig.ENDPOINTS.GET_SUMMARY_BY_RESELLER,
    payload
  );
  return response.data;
};